export const myPartnerBanksForGccData = [
  {
    id: 'uiop',
    text: 'ADCB',
  },
  {
    id: 'uiopfvd',
    text: 'Emirates NBD',
  },
  {
    id: 'uicvop',
    text: 'Citi Bank',
  },
];
export const paymentModeData = [
  {
    id: 'uiop',
    text: 'NEFT',
  },
  {
    id: 'uiops',
    text: 'RTGS',
  },
  {
    id: 'uiopkl',
    text: 'IMPS',
  },
  {
    id: 'uiopklq',
    text: 'Credit Card',
  },
  {
    id: 'uiopklr',
    text: 'Debit Card',
  },
  {
    id: 'uiopks',
    text: 'UPI',
  },
  {
    id: 'uiopklt',
    text: 'Net Banking',
  },
];

export const selectTimeData = [
  {
    text: '00:00',
    id: 0,
  },
  {
    text: '00:10',
    id: 1,
  },
  {
    text: '00:20',
    id: 2,
  },
  {
    text: '00:30',
    id: 3,
  },
  {
    text: '00:40',
    id: 4,
  },
  {
    text: '00:50',
    id: 5,
  },
  {
    text: '01:00',
    id: 6,
  },
  {
    text: '01:10',
    id: 7,
  },
  {
    text: '01:20',
    id: 8,
  },
  {
    text: '01:30',
    id: 9,
  },
  {
    text: '01:40',
    id: 10,
  },
  {
    text: '01:50',
    id: 11,
  },
  {
    text: '02:00',
    id: 12,
  },
  {
    text: '02:10',
    id: 13,
  },
  {
    text: '02:20',
    id: 14,
  },
  {
    text: '02:30',
    id: 15,
  },
  {
    text: '02:40',
    id: 16,
  },
  {
    text: '02:50',
    id: 17,
  },
  {
    text: '03:00',
    id: 18,
  },
  {
    text: '03:10',
    id: 19,
  },
  {
    text: '03:20',
    id: 20,
  },
  {
    text: '03:30',
    id: 21,
  },
  {
    text: '03:40',
    id: 22,
  },
  {
    text: '03:50',
    id: 23,
  },
  {
    text: '04:00',
    id: 24,
  },
  {
    text: '04:10',
    id: 25,
  },
  {
    text: '04:20',
    id: 26,
  },
  {
    text: '04:30',
    id: 27,
  },
  {
    text: '04:40',
    id: 28,
  },
  {
    text: '04:50',
    id: 29,
  },
  {
    text: '05:00',
    id: 30,
  },
  {
    text: '05:10',
    id: 31,
  },
  {
    text: '05:20',
    id: 32,
  },
  {
    text: '05:30',
    id: 33,
  },
  {
    text: '05:40',
    id: 34,
  },
  {
    text: '05:50',
    id: 35,
  },
  {
    text: '06:00',
    id: 36,
  },
  {
    text: '06:10',
    id: 37,
  },
  {
    text: '06:20',
    id: 38,
  },
  {
    text: '06:30',
    id: 39,
  },
  {
    text: '06:40',
    id: 40,
  },
  {
    text: '06:50',
    id: 41,
  },
  {
    text: '07:00',
    id: 42,
  },
  {
    text: '07:10',
    id: 43,
  },
  {
    text: '07:20',
    id: 44,
  },
  {
    text: '07:30',
    id: 45,
  },
  {
    text: '07:40',
    id: 46,
  },
  {
    text: '07:50',
    id: 47,
  },
  {
    text: '08:00',
    id: 48,
  },
  {
    text: '08:10',
    id: 49,
  },
  {
    text: '08:20',
    id: 50,
  },
  {
    text: '08:30',
    id: 51,
  },
  {
    text: '08:40',
    id: 52,
  },
  {
    text: '08:50',
    id: 53,
  },
  {
    text: '09:00',
    id: 54,
  },
  {
    text: '09:10',
    id: 55,
  },
  {
    text: '09:20',
    id: 56,
  },
  {
    text: '09:30',
    id: 57,
  },
  {
    text: '09:40',
    id: 58,
  },
  {
    text: '09:50',
    id: 59,
  },
  {
    text: '10:00',
    id: 60,
  },
  {
    text: '10:10',
    id: 61,
  },
  {
    text: '10:20',
    id: 62,
  },
  {
    text: '10:30',
    id: 63,
  },
  {
    text: '10:40',
    id: 64,
  },
  {
    text: '10:50',
    id: 65,
  },
  {
    text: '11:00',
    id: 66,
  },
  {
    text: '11:10',
    id: 67,
  },
  {
    text: '11:20',
    id: 68,
  },
  {
    text: '11:30',
    id: 69,
  },
  {
    text: '11:40',
    id: 70,
  },
  {
    text: '11:50',
    id: 71,
  },
  {
    text: '12:00',
    id: 72,
  },
  {
    text: '12:10',
    id: 73,
  },
  {
    text: '12:20',
    id: 74,
  },
  {
    text: '12:30',
    id: 75,
  },
  {
    text: '12:40',
    id: 76,
  },
  {
    text: '12:50',
    id: 77,
  },
  {
    text: '13:00',
    id: 78,
  },
  {
    text: '13:10',
    id: 79,
  },
  {
    text: '13:20',
    id: 80,
  },
  {
    text: '13:30',
    id: 81,
  },
  {
    text: '13:40',
    id: 82,
  },
  {
    text: '13:50',
    id: 83,
  },
  {
    text: '14:00',
    id: 84,
  },
  {
    text: '14:10',
    id: 85,
  },
  {
    text: '14:20',
    id: 86,
  },
  {
    text: '14:30',
    id: 87,
  },
  {
    text: '14:40',
    id: 88,
  },
  {
    text: '14:50',
    id: 89,
  },
  {
    text: '15:00',
    id: 90,
  },
  {
    text: '15:10',
    id: 91,
  },
  {
    text: '15:20',
    id: 92,
  },
  {
    text: '15:30',
    id: 93,
  },
  {
    text: '15:40',
    id: 94,
  },
  {
    text: '15:50',
    id: 95,
  },
  {
    text: '16:00',
    id: 96,
  },
  {
    text: '16:10',
    id: 97,
  },
  {
    text: '16:20',
    id: 98,
  },
  {
    text: '16:30',
    id: 99,
  },
  {
    text: '16:40',
    id: 100,
  },
  {
    text: '16:50',
    id: 101,
  },
  {
    text: '17:00',
    id: 102,
  },
  {
    text: '17:10',
    id: 103,
  },
  {
    text: '17:20',
    id: 104,
  },
  {
    text: '17:30',
    id: 105,
  },
  {
    text: '17:40',
    id: 106,
  },
  {
    text: '17:50',
    id: 107,
  },
  {
    text: '18:00',
    id: 108,
  },
  {
    text: '18:10',
    id: 109,
  },
  {
    text: '18:20',
    id: 110,
  },
  {
    text: '18:30',
    id: 111,
  },
  {
    text: '18:40',
    id: 112,
  },
  {
    text: '18:50',
    id: 113,
  },
  {
    text: '19:00',
    id: 114,
  },
  {
    text: '19:10',
    id: 115,
  },
  {
    text: '19:20',
    id: 116,
  },
  {
    text: '19:30',
    id: 117,
  },
  {
    text: '19:40',
    id: 118,
  },
  {
    text: '19:50',
    id: 119,
  },
  {
    text: '20:00',
    id: 120,
  },
  {
    text: '20:10',
    id: 121,
  },
  {
    text: '20:20',
    id: 122,
  },
  {
    text: '20:30',
    id: 123,
  },
  {
    text: '20:40',
    id: 124,
  },
  {
    text: '20:50',
    id: 125,
  },
  {
    text: '21:00',
    id: 126,
  },
  {
    text: '21:10',
    id: 127,
  },
  {
    text: '21:20',
    id: 128,
  },
  {
    text: '21:30',
    id: 129,
  },
  {
    text: '21:40',
    id: 130,
  },
  {
    text: '21:50',
    id: 131,
  },
  {
    text: '22:00',
    id: 132,
  },
  {
    text: '22:10',
    id: 133,
  },
  {
    text: '22:20',
    id: 134,
  },
  {
    text: '22:30',
    id: 135,
  },
  {
    text: '22:40',
    id: 136,
  },
  {
    text: '22:50',
    id: 137,
  },
  {
    text: '23:00',
    id: 138,
  },
  {
    text: '23:10',
    id: 139,
  },
  {
    text: '23:20',
    id: 140,
  },
  {
    text: '23:30',
    id: 141,
  },
  {
    text: '23:40',
    id: 142,
  },
  {
    text: '23:50',
    id: 143,
  },
];

export const bankNames = [
  {
    id: 'ghs',
    text: 'HDFC Bank',
  },
  {
    id: 'ghs3',
    text: 'Axis Bank',
  },
  {
    id: 'ghs38u',
    text: 'SBI Bank',
  },
];

export const supportRequestList = [
  {
    id: '23er1',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'submitted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er2',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Rejected',
    status: 'rejected',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er3',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Accepted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er4',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er5',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er6',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er7',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er8',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er9',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
  {
    id: '23er10',
    transactionDate: '24/04/2022',
    transactionTime: '22:36',
    requestID: 'NH2219475862006',
    utr: 'NH22194758620061234567895',
    amount: '₹1,48,293',
    paymentMode: 'NEFT',
    statusText: 'Request Submitted',
    status: 'accepted',
    statusNotes: 'Amount not received against shared details',
  },
];

export const bankName = [
  'Airtel Payment Bank',
  'Allahabad Bank',
  'Au Bank',
  'Au Small Finance Bank',
  'Axis Bank',
  'Bandhan Bank',
  'Bank Of Baroda Corporate',
  'Bank Of Baroda Retail',
  'Bank Of India',
  'Bank Of Maharashtra',
  'Canara Bank',
  'Catholic Syrian Bank',
  'Central Bank Of India',
  'City Union Bank',
  'Corporate Punjab National Bank',
  'Corporation Bank',
  'Cosmos Bank',
  'DCB Bank',
  'Deutsche Bank',
  'Dhanlaxmi Bank',
  'Equitas Bank',
  'Federal Bank',
  'HDFC Bank',
  'HSBC Bank',
  'ICICI Bank',
  'IDBI Bank',
  'IDFC Bank',
  'Indian Bank',
  'Indian Overseas Bank',
  'Indusind Bank',
  'J & K Bank',
  'Jana Bank',
  'Janata Sahakari Bank',
  'Karnataka Bank',
  'Karur Vsya Bank',
  'Kotak Bank',
  'Laxmi Vilas Bank',
  'Oriental Bank',
  'Punjab & Sindh Bank',
  'Punjab National Bank Retail',
  'Punjab National Bank Corporate',
  'RBL Bank',
  'Saraswat Bank',
  'Shamrao Vithal Co-Op. Bank Ltd',
  'Shamro Bank Pvt Ltd',
  'South Indian Bank',
  'Standard Chartered Bank',
  'State Bank Of India',
  'Tamilnad Mercantile Bank Ltd.',
  'TJSB Bank',
  'UCO Bank',
  'Union Bank Of India',
  'Vijaya Bank',
  'Yes Bank',
];
